import React from 'react';
import classNames from 'classnames';

import bind from '../bind';
import OverflowingRow from './overflowing_row';
import Tiles from './tiles';
import ArticleCollectionCard from './article_collection_card';
import { CommonsCmsArticlesCollection } from '../rql';

interface IProps {
  title?: JSX.Element | React.ReactNode | string;
  titleHtml?: string;
  subtitle?: string;
  subtitleHtml?: string;
  ledeHtml?: string;
  action?: JSX.Element | React.ReactNode;
  articles?: CommonsCmsArticlesCollection.Articles[];
  id?: string;
  loading?: boolean;
  expectedCount?: number;
  renderForSidebar?: boolean;
  cardStyle?: string;
}

export default class ArticleCollectionView extends React.Component<IProps, null> {
  static defaultProps = {
    articles: [],
    expectedCount: 3,
  };

  @bind
  renderArticle(article) {
    return (
      <ArticleCollectionCard
        article={article}
        renderForSidebar={this.props.renderForSidebar}
        key={article && article.id}
        cardStyle={this.props.cardStyle}
      />
    );
  }

  renderForSidebar() {
    const classes = classNames(
      'sidebar-articles',
      { 'sidebar-articles--loading': this.props.loading },
    );

    return (
      <div className={classes}>
        <h4
          className="sidebar-articles__heading"
        >
          {this.props.title}
        </h4>
        <Tiles
          oneWide
          placeholder={this.renderArticle(null)}
          expectedCount={this.props.expectedCount}
          loading={this.props.loading}
        >
          {this.props.articles.map(this.renderArticle)}
        </Tiles>
      </div>
    );
  }

  render() {
    if (!this.props.loading && !this.props.articles.length) {
      return null;
    }

    if (this.props.renderForSidebar) return this.renderForSidebar();

    return (
      <OverflowingRow
        title={this.props.title}
        titleHtml={this.props.titleHtml}
        subtitle={this.props.subtitle}
        subtitleHtml={this.props.subtitleHtml}
        ledeHtml={this.props.ledeHtml}
        collectionCount={this.props.articles.length}
        action={this.props.action}
        id={this.props.id}
      >
        <Tiles
          threeWide
          singleRow
          grow
          placeholder={this.renderArticle(null)}
          expectedCount={this.props.expectedCount}
          loading={this.props.loading}
        >
          {this.props.articles.map(this.renderArticle)}
        </Tiles>
      </OverflowingRow>
    );
  }
}
